import clsx from 'clsx'
import { FunctionComponent, ReactNode } from 'react'
import { useThemeBackground } from '../../hooks/useTheme'
import type { TimerViewport } from '../../viewport'
import ClockFrame from '../molecules/ClockFrame'
import ClockHands from '../molecules/ClockHands'
import { TimerGauge } from './gauge/TimerGauge'
import { TimerInfoState } from './utils/TimerInfoState'
import { TimerTickInfoState } from './utils/TimerTickInfoState'

// tslint:disable: object-literal-sort-keys
export const DEFAULT_VIEWPORT = {
  top: 0,
  left: 0,
  right: 600,
  bottom: 600,
  center: {
    x: 300,
    y: 300,
  },
  width: 600,
  height: 600,
}

export interface TimerClockProps {
  className?: string
  viewport?: TimerViewport
  stroke?: number
  time?: Date
  children?: ReactNode
}

export default function TimerClock({ viewport = DEFAULT_VIEWPORT, className }: TimerClockProps) {
  return (
    <div className={className}>
      <ClockComponent viewport={viewport} />
    </div>
  )
}

interface ClockComponentProps {
  viewport: TimerViewport
  children?: ReactNode
}

const ClockComponent: FunctionComponent<ClockComponentProps> = ({ viewport, children }: ClockComponentProps) => {
  const { color } = useThemeBackground()
  const clockConfig = {
    fill: '#ffdd00',
    stroke: '#ff0000',
    frameColor: '#ffffff',
  }
  const radius = viewport.center.x - 10

  return (
    <svg
      id="svg-id"
      viewBox={`${viewport.top} ${viewport.left} ${viewport.width} ${viewport.height}`}
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <TimerInfoState>
          {({ timer }) => {
            let fillColor = 'transparent'
            let isWorking = false
            if (timer && !timer.is_finished) {
              isWorking = true
              fillColor = timer?.task && timer.task.color_name !== 'transparent' ? timer.task.color_code : color
            }
            return (
              <rect
                className={clsx('transition-all duration-0', isWorking && 'delay-1000')}
                fill={fillColor}
                x={viewport.left}
                width={viewport.width}
                y={viewport.top}
                height={viewport.height}
              />
            )
          }}
        </TimerInfoState>

        <ClockFrame viewport={viewport} radius={radius} frameColor={clockConfig.frameColor} fill={clockConfig.fill}>
          <TimerGauge viewport={viewport} radius={radius} />
        </ClockFrame>
        <TimerTickInfoState>
          {({ tick }) => <ClockHands tick={tick} viewport={viewport} color={clockConfig.stroke} radius={radius} />}
        </TimerTickInfoState>
        {children}
      </g>
    </svg>
  )
}
